import { render, staticRenderFns } from "./product-fba-tail.vue?vue&type=template&id=553693a4&scoped=true&"
import script from "./product-fba-tail.vue?vue&type=script&lang=js&"
export * from "./product-fba-tail.vue?vue&type=script&lang=js&"
import style0 from "./product-fba-tail.vue?vue&type=style&index=0&id=553693a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553693a4",
  null
  
)

export default component.exports